import React, { useState, forwardRef, useImperativeHandle, useRef, useEffect } from 'react';

import Button from './Button';


const ReplaceableContent = forwardRef(({ title, content, form, buttonLabel, children, style }, ref) => {
  const [showForm, setShowForm] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const internalRef = useRef(null);

  useImperativeHandle(ref, () => internalRef.current);

  const hasForm = Boolean(form);

  const handleShowForm = () => setShowForm(true);
  const handleShowContent = () => {
    setShowForm(false);
    setShowSuccessMessage(false);
  };

  const handleFormSubmit = async (formData) => {
    try {
      const submissionData = { ...formData, category: buttonLabel };

      if (buttonLabel === 'Contact Us') {
        submissionData.company = formData.companyName;
        submissionData.message = formData.message;
      }

      console.log(submissionData);

      await fetch(
        'https://script.google.com/macros/s/AKfycbxJ1QeSTIrHzvtVHCIeCYo7pHyZ4mesfOTRtOaUEv2KgOdVsUcr12y7ckMI3xuoUtEw/exec',
        {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(submissionData),
        }
      );

      setShowForm(false);
      setShowSuccessMessage(true);

      if (title !== 'Corporations' && title !== 'UMD Professors') {
        setTimeout(() => setShowSuccessMessage(false), 3000);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  let displayedContent;

  if (showSuccessMessage) {
    if (title === 'Corporations' || title === 'UMD Professors') {
      displayedContent = (
        <div>
          <p>Success! Do Quantum related or just networking, feel free to...</p>
          <Button
            label="Schedule a Call"
            onClick={() => window.open('https://calendar.app.google/gJMJrDGHgyvSuQCT8')}
          />
        </div>
      );
    } else {
      displayedContent = <p>Success! Your submission has been received.</p>;
    }
  } else if (hasForm && showForm) {
    const clonedForm = React.cloneElement(form, {
      onSubmit: async (event) => {
        event.preventDefault();
        const formData = Object.fromEntries(new FormData(event.target).entries());
        await handleFormSubmit(formData);
      },
    });
    displayedContent = (
      <div>
        {clonedForm}
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
          <Button label="Back" onClick={handleShowContent} />
        </div>
      </div>
    );
    } else {
  displayedContent = (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    }}>
      {/* Subtitle */}
      {content && (
        <p style={{
          fontSize: '1.1rem',
          marginBottom: '1rem',
        }}>{content}</p>
      )}

      {/* Center Content */}
      <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {children}
      </div>

      {/* Button */}
      {buttonLabel && (
        <div style={{ marginTop: '1rem' }}>
          <Button
            label={buttonLabel}
            onClick={() => {
              if (hasForm) {
                handleShowForm();
              } else {
                if (buttonLabel === 'See Current Chapter') {
                  window.location.href = '/chapters/umd';
                } else if (buttonLabel === 'See Research Projects') {
                  window.location.href = '/projects';
                } else if (buttonLabel === 'See Workshop Process') {
                  window.location.href = '/workshops';
                }
              }
            }}
          />
        </div>
      )}

    </div>
  );
}



  return (
    <div
      ref={internalRef}
      style={{
        ...style,
        background: showForm || showSuccessMessage
          ? 'rgba(99, 102, 241, 0.2)'
          : 'rgba(99, 102, 241, 0.05)',
        padding: '1.5rem .8rem',
        borderRadius: '0.75rem',
        marginBottom: '1rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      {title && (
        <h1 className="title">
          {title}
        </h1>
      )}
      {displayedContent}
    </div>
  );
});

export default ReplaceableContent;